export default __webpack_public_path__ + "static/plan-3f7a3dff17fe97593d3d1eed86e4728c.jpeg";